import { connectionStore } from "../../Stores";
import { RESTClient } from "../../Network";
export function createRESTConn(params) {
    const conn = new RESTClient({
        handlers: {
            requestFormatter: params.handlers.requestFormatter,
            responseFormatter: params.handlers.responseFormatter
        }
    });
    connectionStore.set(params.name, conn);
    return conn;
}
//# sourceMappingURL=CreateRESTConn.js.map